import { LINKS } from "./constants";

export enum Environment {
  LOCAL = "LOCAL",
  DEV = "DEV",
  OFFICIAL = "OFFICIAL"
}

export const getLiteUrl = () => {
  if (getEnv() !== Environment.OFFICIAL) {
    return LINKS.LITE_MSP.DEV;
  }
  return LINKS.LITE_MSP.OFFICIAL;
}

export function getEnv(): Environment {
  /* local */
  if (process.env.NODE_ENV === 'development') return Environment.LOCAL
  /* online */
  const { host } = window.location;
  return host.endsWith("dd.firewalla.net") ? Environment.DEV : Environment.OFFICIAL;
}